import { render, staticRenderFns } from "./places-context-menu-factory.vue?vue&type=template&id=a9876710"
import script from "./places-context-menu-factory.vue?vue&type=script&lang=js"
export * from "./places-context-menu-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports